import type { I18nKey } from 'types/i18n'

import {
    ROUTE_CONFIGURACION_NIVEL_APROBACION,
    ROUTE_CONFIGURACION_TIPO_CONVENIO,
    ROUTE_TRANSACCIONES_APROBACION_CONVENIO,
    ROUTE_TRANSACCIONES_CONVENIO,
    ROUTE_TRANSACCIONES_GESTION_CONVENIO,
} from './names'
import { buildBreadcrumb } from '@/@core/utils/router'
import permission, { RESOURCE_CONVENIOS } from '@/auth/permissions/modules/convenios'
import { defineRoutes } from '@/utils/router'

//#region helpers
const breadcrumbConfiguracion = (option: I18nKey) =>
    buildBreadcrumb('a:convenios.menu_title', 'a:global.menu.configuracion', option)
const breadcrumbTransacciones = (option: I18nKey) =>
    buildBreadcrumb('a:convenios.menu_title', 'a:global.menu.transacciones', option)

const { configuracion, transacciones } = permission

export default defineRoutes([
    /**
     * Rutas de Configuración
     */
    {
        path: '/convenios/configuracion/tipos-convenio',
        name: ROUTE_CONFIGURACION_TIPO_CONVENIO,
        component: () => import('@pages/convenios/configuracion/TipoConvenio.vue'),
        meta: {
            title: 'i18n:convenios.subopciones.tipo_convenio',
            action: configuracion.tipoConvenio,
            resource: RESOURCE_CONVENIOS,
            breadcrumbs: breadcrumbConfiguracion('convenios.subopciones.tipo_convenio'),
        },
    },
    {
        path: '/convenios/configuracion/niveles-aprobacion',
        name: ROUTE_CONFIGURACION_NIVEL_APROBACION,
        component: () => import('@pages/convenios/configuracion/NivelAprobacionConvenio.vue'),
        meta: {
            title: 'i18n:convenios.subopciones.nivel_aprobacion',
            action: configuracion.nivelAprobacion,
            resource: RESOURCE_CONVENIOS,
            breadcrumbs: breadcrumbConfiguracion('convenios.subopciones.nivel_aprobacion'),
        },
    },

    /**
     * Rutas de Transacciones
     */
    {
        path: '/convenios/transacciones/gestion-convenio',
        name: ROUTE_TRANSACCIONES_GESTION_CONVENIO,
        component: () => import('@pages/convenios/transacciones/GestionConvenio.vue'),
        meta: {
            title: 'i18n:convenios.subopciones.gestion_convenio',
            action: transacciones.convenios.gestionConvenios,
            resource: RESOURCE_CONVENIOS,
            breadcrumbs: breadcrumbTransacciones('convenios.subopciones.gestion_convenio'),
        },
    },
    {
        path: '/convenios/transacciones/convenio/:numeroConvenio?',
        name: ROUTE_TRANSACCIONES_CONVENIO,
        component: () => import('@pages/convenios/transacciones/convenio/Index.vue'),
        meta: {
            title: 'i18n:convenios.subopciones.convenio',
            action: transacciones.convenios.gestionConvenios,
            resource: RESOURCE_CONVENIOS,
            breadcrumbs: breadcrumbTransacciones('convenios.subopciones.convenio'),
        },
    },
    {
        path: '/convenios/transacciones/aprobacion-convenio',
        name: ROUTE_TRANSACCIONES_APROBACION_CONVENIO,
        component: () => import('@pages/convenios/transacciones/aprobacion-convenio/Index.vue'),
        meta: {
            title: 'i18n:convenios.subopciones.aprobacion_convenio',
            action: transacciones.convenios.aprobacionConvenio,
            resource: RESOURCE_CONVENIOS,
            breadcrumbs: breadcrumbTransacciones('convenios.subopciones.aprobacion_convenio'),
        },
    },
])
